import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blanks-region',
  templateUrl: './blanks-region.component.html'
})
export class BlanksRegionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
